import React, {
  useEffect,
  useState,
} from 'react';

import {
  Modal,
  Spin,
  Rate,
  message,
  Button,
} from 'antd';

import jsPDF from 'jspdf';

import html2canvas from 'html2canvas';

import { TrainingsApi } from '../../Api/TrainingsApi';

const TraineeFeedbackDownload = ({
  open,
  onClose,
  trainingId,
  traineeId,
}) => {
  // ================= STATES =================

  const [loading, setLoading] =
    useState(false);

  const [data, setData] =
    useState(null);

  // ================= API =================

  useEffect(() => {
    if (
      open &&
      trainingId &&
      traineeId
    ) {
      getFeedbackDetails();
    }
  }, [
    open,
    trainingId,
    traineeId,
  ]);

  const getFeedbackDetails =
    async () => {
      try {
        setLoading(true);

        const payload = {
          training_id:
            trainingId,

          trainee_id:
            traineeId,
        };

        const response =
          await TrainingsApi.getTraineeFeedbackDownload(
            payload
          );

        if (response.data.success) {
          setData(
            response.data.result
          );
        } else {
          message.error(
            response.data.message
          );
        }
      } catch (error) {
        console.log(error);

        message.error(
          'Failed to fetch feedback details'
        );
      } finally {
        setLoading(false);
      }
    };

  // ================= DOWNLOAD PDF =================

  const handleDownloadPDF =
    async () => {
      const input =
        document.getElementById(
          'feedback-report'
        );

      const canvas =
        await html2canvas(input, {
          scale: 2,
        });

      const imgData =
        canvas.toDataURL(
          'image/png'
        );

      const pdf =
        new jsPDF(
          'p',
          'mm',
          'a4'
        );

      const imgWidth = 210;

      const pageHeight = 295;

      const imgHeight =
        (canvas.height *
          imgWidth) /
        canvas.width;

      let heightLeft =
        imgHeight;

      let position = 0;

      pdf.addImage(
        imgData,
        'PNG',
        0,
        position,
        imgWidth,
        imgHeight
      );

      heightLeft -=
        pageHeight;

      while (heightLeft >= 0) {
        position =
          heightLeft -
          imgHeight;

        pdf.addPage();

        pdf.addImage(
          imgData,
          'PNG',
          0,
          position,
          imgWidth,
          imgHeight
        );

        heightLeft -=
          pageHeight;
      }

      pdf.save(
        'Training_Feedback_Report.pdf'
      );
    };

  // ================= DATA =================

  const trainingDetails =
    data?.training_details;

  const traineeDetails =
    data?.trainee_details;

  const trainerDetails =
    data?.trainer_details;

  const questions =
    data?.feedback_response
      ?.questions || [];

  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      width={800}
      centered
    >
      {loading ? (
        <div className="text-center p-5">
        
        </div>
      ) : (
        <>
          {/* ================= REPORT ================= */}

          <div
            id="feedback-report"
            style={{
              background: '#fff',
              padding: 30,
              border:
                '1px solid #000',
            }}
          >
            {/* ================= HEADER ================= */}

            <div
              style={{
                textAlign: 'center',
                marginBottom: 30,
              }}
            >
              <h1
                style={{
                  fontSize: 24,
                  fontWeight: 700,
                  marginBottom: 10,
                }}
              >
                Openwave Computing
                Services Pvt. Ltd.
              </h1>

              <h2
                style={{
                  fontSize: 18,
                  marginBottom: 14,
                }}
              >
                Field Training
                Feedback Form
              </h2>

              <p
                style={{
                  color: '#555',
                  fontStyle:
                    'italic',
                }}
              >
                "This form is to
                be used for
                trainings
                conducted by
                internal or
                external
                faculty."
              </p>
            </div>

            {/* ================= SECTION 1 ================= */}

            <div
              style={{
                marginBottom: 30,
              }}
            >
              <h3
                style={{
                  marginBottom: 20,
                  borderBottom:
                    '1px solid #d1d5db',
                  paddingBottom: 10,
                }}
              >
                Section 1 –
                Training
                Details
              </h3>

              <div
                style={{
                  marginBottom: 18,
                }}
              >
                <b>
                  Name of the
                  Training:
                </b>{' '}
                {
                  trainingDetails?.training_name
                }
              </div>

              <div
                style={{
                  marginBottom: 18,
                }}
              >
                <b>
                  Name of the
                  Associate:
                </b>{' '}
                {
                  traineeDetails?.trainee_name
                }
              </div>

              <div
                style={{
                  marginBottom: 18,
                }}
              >
                <b>
                  Date of the
                  Training:
                </b>{' '}
                {
                  trainingDetails?.training_date
                }
              </div>

              <div
                style={{
                  marginBottom: 18,
                }}
              >
                <b>
                  Department /
                  Team:
                </b>{' '}
                {
                  trainingDetails?.department_name
                }
              </div>

              <div
                style={{
                  marginBottom: 18,
                }}
              >
                <b>
                  Name of the
                  Trainer:
                </b>{' '}
                {
                  trainerDetails?.trainers
                }
              </div>

              <div
                style={{
                  marginBottom: 18,
                }}
              >
                <b>
                  Training
                  Venue:
                </b>{' '}
                {
                  trainingDetails?.venue
                }
              </div>
            </div>

            {/* ================= QUESTIONS ================= */}

            <div>
              <h3
                style={{
                  marginBottom: 20,
                  borderBottom:
                    '1px solid #d1d5db',
                  paddingBottom: 10,
                }}
              >
                Section 2 –
                Feedback
                Questions
              </h3>

              {questions.map(
                (
                  question,
                  index
                ) => (
                  <div
                    key={index}
                    style={{
                      marginBottom: 28,
                    }}
                  >
                    {/* QUESTION */}

                    <div
                      style={{
                        fontWeight: 600,
                        marginBottom: 12,
                        fontSize: 16,
                      }}
                    >
                      {
                        question.question_no
                      }
                      .{' '}
                      {
                        question.question
                      }
                    </div>

                    {/* TEXT */}

                    {question.type ===
                      'text' && (
                      <div
                        style={{
                          minHeight: 80,
                          border:
                            '1px solid #cbd5e1',
                          padding: 14,
                        }}
                      >
                        {
                          question.answer
                        }
                      </div>
                    )}

                    {/* RATING */}

                    {question.type === 'rating_group' && (
                      <div style={{ marginTop: 10 }}>
                        <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 8, fontSize: '12px', color: '#666', fontWeight: 500 }}>
                          Low &nbsp; &rarr; &nbsp; Medium &nbsp; &rarr; &nbsp; High
                        </div>
                        <table style={{ width: '100%', borderCollapse: 'collapse', border: '1px solid #d1d5db', fontSize: '13px' }}>
                          <thead>
                            <tr style={{ backgroundColor: '#f8f9fa' }}>
                              <th style={{ border: '1px solid #d1d5db', padding: '12px 10px', textAlign: 'left', color: '#374151', fontWeight: 600 }}>Criteria</th>
                              {[...Array(10)].map((_, i) => (
                                <th key={i} style={{ border: '1px solid #d1d5db', padding: '12px 5px', textAlign: 'center', width: '40px', color: '#374151', fontWeight: 600 }}>{i + 1}</th>
                              ))}
                            </tr>
                          </thead>
                          <tbody>
                            {question.ratings?.map((rating, rIdx) => (
                              <tr key={rIdx}>
                                <td style={{ border: '1px solid #d1d5db', padding: '10px', color: '#4b5563' }}>
                                  {rating.label || rating}
                                </td>
                                {[...Array(10)].map((_, i) => {
                                  const val = i + 1;
                                  const isSelected = Number(rating.value) === val;
                                  return (
                                    <td key={i} style={{ border: '1px solid #d1d5db', padding: '8px 5px', textAlign: 'center' }}>
                                      <div style={{
                                        width: '18px',
                                        height: '18px',
                                        borderRadius: '50%',
                                        border: `1.5px solid ${isSelected ? '#1890ff' : '#9ca3af'}`,
                                        margin: '0 auto',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        backgroundColor: isSelected ? '#1890ff' : 'transparent',
                                        transition: 'all 0.2s'
                                      }}>
                                        {isSelected && (
                                          <div style={{
                                            width: '8px',
                                            height: '8px',
                                            borderRadius: '50%',
                                            backgroundColor: '#fff'
                                          }} />
                                        )}
                                      </div>
                                    </td>
                                  );
                                })}
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    )}
                  </div>
                )
              )}
            </div>

            {/* ================= FOOTER ================= */}

            <div
              style={{
                marginTop: 60,
                display: 'flex',
                justifyContent:
                  'space-between',
              }}
            >
              <div>
                <div
                  style={{
                    marginBottom: 50,
                  }}
                >
                  Associate
                  Signature:
                </div>

                <div
                  style={{
                    width: 250,
                    borderBottom:
                      '1px solid #000',
                  }}
                />
              </div>

              <div>
                <div
                  style={{
                    marginBottom: 50,
                  }}
                >
                  Date:
                </div>

                <div
                  style={{
                    width: 250,
                    borderBottom:
                      '1px solid #000',
                  }}
                />
              </div>
            </div>
          </div>

          {/* ================= BUTTONS ================= */}

          <div
            style={{
              display: 'flex',
              justifyContent:
                'center',
              gap: 12,
              marginTop: 20,
            }}
          >
            <Button
              onClick={onClose}
            >
              Back
            </Button>

            <Button
              type="primary"
              onClick={
                handleDownloadPDF
              }
            >
              Download Report
            </Button>
          </div>
        </>
      )}
    </Modal>
  );
};

export default TraineeFeedbackDownload;